export {default} from './watchlist.container';
export const path = "/saved";